/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  Button,
  Card,
  Col,
  Form,
  Input,
  List,
  Popconfirm,
  Row,
  message,
  Upload,
} from "antd";

import React, { useState } from "react";
import { v4 as uuidv4 } from "uuid";
import EditItems from "./EditItems";

const { Dragger } = Upload;
const { TextArea } = Input;
const ItemCards = (props) => {
  const { data, deleteItem, onAdd, onUpdateItemStatus, onUpdateItemFollowUp,onEdit,deleteItemsByKey } =
    props;
  const [listItems, setListItems] = useState([]);
  const [itemName, setItemName] = useState([]);
  const [listEditItem, setListEditItem] = useState([]);
  const [isItemOk, setIsItemOk] = useState(false);

  function handleAddCards() {
    const newList = listItems.concat({ id: uuidv4() });

    setListItems(newList);
  }

  function handleRemoveAccount(id) {
    deleteItem(id);
    setListItems([]);
  }

  const [form] = Form.useForm();

  const onFinish = (values) => {
    console.log("Form submitted!", values);
  };

  const handleAddItems = () => {
    onAdd(itemName, data.key);
    setListItems([]);
  };

  function handleBlur() {
    form.submit();
  }

  const handleInput = (e) => {
    setItemName({
      key: e.target.value,
      itemTitle: e.target.value,
    });
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleItemStatus = (id, value) => {
    const isDone = value ? false : true;

    onUpdateItemStatus(data.key, id, isDone);
  };

  const handleItemFollowUp = (id, newValue) => {
    const isFollow = newValue ? false : true;
    onUpdateItemFollowUp(data.key, id, isFollow);
  };

  const handleEdit = (id) => {
    setListEditItem((listEditItem) => [...listEditItem, { id: id }]);
  };

  const validateInput = (_, value) => {
    if (!value) {
      return Promise.reject("can't be blank");
    }
    return Promise.resolve();
  };

  const PhotoProps = {
    name: "file",
    multiple: true,
    onChange(info) {
      const { status } = info.file;
      if (status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (status === "done") {
        message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },
  };

  
  function filterEditItem(id) {
    const newData = listEditItem.filter(item => item.id !== id);
    setListEditItem(newData);
  }
  return (
    <div>
      <Card
        title={data.itemCardTitle}
        id={data.itemCardTitle}
        extra={
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => handleRemoveAccount(data.key)}
          >
            <a style={{ color: "red" }}>Delete Area</a>
          </Popconfirm>
        }
      >
        <List
          className="demo-loadmore-list"
          itemLayout="horizontal"
          dataSource={data.items}
          renderItem={(item) => (
            <div key={item.key}>
              {listEditItem.map((listData) =>
                listData.id === item.key ? <EditItems key={listData.id} data={item} onEditValue={onEdit} cardKey={data.key} filterEditList={filterEditItem} deleteItemsByKey={deleteItemsByKey}/> : null
              )}
              {listEditItem.some(
                (listEdit) => listEdit.id === item.key
              ) ? null : (
                <Card size="small" id={item.key}>
                  <List.Item
                    actions={[
                      <a
                        key="list-loadmore-ok"
                        style={
                          item.isDone
                            ? { color: "#008A00" }
                            : { color: "#627887" }
                        }
                        onClick={() => handleItemStatus(item.key, item.isDone)}
                      >
                        <i className="fa-sharp fa-solid fa-circle-check"></i> OK
                      </a>,
                      <a
                        key="list-loadmore-followup"
                        style={
                          item.isFollowUp
                            ? { color: "#CB0909" }
                            : { color: "#627887" }
                        }
                        onClick={() =>
                          handleItemFollowUp(item.key, item.isFollowUp)
                        }
                      >
                        <i className="fa-solid fa-flag"></i> FOLLOW-UP
                      </a>,
                      <a
                        key="list-loadmore-edit"
                        onClick={() => handleEdit(item.key)}
                      >
                        Edit
                      </a>,
                    ]}
                  >
                    <List.Item.Meta title={<span>{item.itemTitle}</span>} />
                  </List.Item>
                </Card>
              )}
            </div>
          )}
          locale={{
            emptyText: " ",
          }}
        />
        {listItems.map((item, index) => (
          <Card key={item.key}>
            <Form
              name="basic"
              labelCol={{
                span: 8,
              }}
              initialValues={{
                remember: true,
              }}
              form={form}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
              layout="vertical"
            >
              <Row justify="space-between">
                <Col span={18}>
                  <Form.Item
                    name={`cardItemTitle${index}`}
                    rules={[{ validator: validateInput }]}
                    label="Name"
                    required
                  >
                    <Input
                      autoFocus
                      onBlur={handleBlur}
                      onChange={handleInput}
                      style={{ width: "30%" }}
                    />
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Row justify="space-between">
                    <Col>
                      <a
                        style={
                          isItemOk ? { color: "#008A00" } : { color: "#627887" }
                        }
                        onClick={() => setIsItemOk(!isItemOk)}
                      >
                        <i className="fa-sharp fa-solid fa-circle-check"></i> OK
                      </a>
                    </Col>
                    <Col>
                      <a style={{ color: "#627887" }}>
                        <i className="fa-solid fa-flag"></i> FOLLOW-UP
                      </a>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <Form.Item label="Description">
                    <TextArea
                      style={{
                        height: 80,
                      }}
                      placeholder="Enter some details for this item..."
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Form.Item label="Add Photos">
                <Dragger {...PhotoProps}>
                  <Row justify="center">
                    <Col>
                      <p className="ant-upload-text">Drag Photos Here</p>
                    </Col>
                    <Col span={1}>or</Col>
                    <Col>
                      <Button>Choose Photos to Add</Button>
                    </Col>
                  </Row>
                </Dragger>
              </Form.Item>

              <Row justify="space-between">
                <Col span={6}>
                  <Button
                    type="primary"
                    style={{ marginRight: "10px" }}
                    onClick={handleAddItems}
                  >
                    Save
                  </Button>
                  <Button onClick={() => handleRemoveAccount(item.id)}>
                    Cancel
                  </Button>
                </Col>
                <Col span={2}>
                  <Form.Item>
                    <Popconfirm
                      title="Sure to delete?"
                      onConfirm={() => handleRemoveAccount(item.id)}
                    >
                      <a style={{ color: "red" }}>Delete Area</a>
                    </Popconfirm>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Card>
        ))}
        <Button type="link" style={{ width: "100%" }} onClick={handleAddCards}>
          <i className="fa-solid fa-plus" style={{ marginRight: "5px" }}></i>{" "}
          Add Item
        </Button>
      </Card>
      <br />

    </div>
  );
};

export default ItemCards;
